import { create } from 'zustand';
import { getRouterUrl } from '@/hooks/useRouter';

export interface IState {
    routerHistory: any;
    routerPush: (path: string, query?: Record<string, any>, keepQuery?: boolean) => void;
}
export const useGlobalStore = create<IState>((set, get) => ({
    routerHistory: null,
    routerPush: (path: string, query?: Record<string, any>, keepQuery = true) => {
        const url = getRouterUrl(path, query, keepQuery);
        get().routerHistory.push(url);
    },
}));
